export const IDENTIFIERS = {
  6: {
    name: "Карта банка",
    color: "blue",
    icon: "mdi-credit-card"
  },
  0: {
    name: "Карта Сбербанка",
    color: "green",
    icon: "mdi-credit-card"
  },
  5: {
    name: "Карта учереждения",
    color: "red darken-4",
    icon: "mdi-card-text"
  },
  1: {
    name: "Прочее",
    color: "blue-grey lighten-2",
    icon: "mdi-card"
  }
};

export function getIdentifierName(id) {
  return (IDENTIFIERS[id] || { name: "Н/Д" }).name;
}

export function getIdentifierColor(id) {
  return (IDENTIFIERS[id] || { color: "gray" }).color;
}

export function getIdentifierIcon(id) {
  return (IDENTIFIERS[id] || { icon: "mdi-card" }).icon;
}
